import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { PaymentShareKycModalComponent } from './payment-share-kyc-modal.component';

@NgModule({
  imports: [UiModule, TrackingModule, CommonModule],
  declarations: [PaymentShareKycModalComponent],
})
export class PaymentShareKycModalModule {}
